import React from 'react';
import styled from 'styled-components';

const C3Style = styled.svg``;

export const C3 = ({ color }) => {
	return (
		<C3Style
			xmlns='http://www.w3.org/2000/svg'
			width='23.474'
			height='22.258'
			viewBox='0 0 23.474 22.258'
		>
			<path
				id='high_heels'
				data-name='high heels'
				d='M799.923,446.265h10.512c.368,0,1.331-2.723,2.2-5.183.334-.948.656-1.87.96-2.613a3.82,3.82,0,0,1,1.528-1.917,1.819,1.819,0,0,1,1.112-.237,1.606,1.606,0,0,1,1.051.611,3.572,3.572,0,0,1,.6,2.254v7.084h.791v-9.2a19.56,19.56,0,0,1,.461-3.977c.425-2.164.665-3.378-2.87-5.35l-7.107,13.988a.905.905,0,0,1-.124.185,4.274,4.274,0,0,1-1.14.975,3.192,3.192,0,0,1-1.65.456,2.829,2.829,0,0,1-2.133-1.054l-3.438,1.048a2.732,2.732,0,0,0-.826.5,1.744,1.744,0,0,0,.072,2.424Zm10.512,1.716h-10.9a.856.856,0,0,1-.62-.273,4.81,4.81,0,0,1-.95-1.444,3.475,3.475,0,0,1-.247-1.9,3.1,3.1,0,0,1,.967-1.766,4.321,4.321,0,0,1,1.361-.856v0l.079-.029,4.038-1.227a.859.859,0,0,1,1.039.367c.623,1.075,1.71.909,2.485.015l7.456-14.683h0l0-.006a.85.85,0,0,1,1.146-.371c5.474,2.8,5.146,4.476,4.533,7.6a18.169,18.169,0,0,0-.428,3.648v10.054a.858.858,0,0,1-.856.859h-2.5a.86.86,0,0,1-.857-.859v-7.941a2.24,2.24,0,0,0-.2-1.15l-.024.013a2.142,2.142,0,0,0-.772,1.066c-.3.726-.611,1.614-.936,2.54-1.056,3-2.23,6.331-3.81,6.331Z'
				transform='translate(-797.673 -425.724)'
				fill={color}
			/>
		</C3Style>
	);
};
